<app-breadcrumb [crumbPaths]="[{
    name: 'Home',
    path: '/home',
    active: true
}]"></app-breadcrumb>

<app-conduct-dashboard-report *ngIf="currentUser?.role[0] != 'Client'">
</app-conduct-dashboard-report>

<app-client-add *ngIf="currentUser?.role[0] == 'Client'" [standalone]="false" [clientId]="currentUser.client">

</app-client-add>